import styled from 'styled-components';

const LoadingContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 100vh;
`;

const Spinner = styled.div`
	width: 40px;
	height: 40px;
	border: 4px solid #f3f4f6;
	border-top: 4px solid #3b82f6;
	border-radius: 50%;
	animation: spin 1s linear infinite;

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
`;

/**
 * Loading spinner displayed while checking authentication
 */
export default function LoadingState() {
	return (
		<LoadingContainer>
			<Spinner />
		</LoadingContainer>
	);
}
